var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLinkedCloud = function SvgLinkedCloud(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 4a4.002 4.002 0 0 0-3.92 3.2l-.168.829L6.067 8A2 2 0 1 0 6 12h11a3 3 0 1 0-1.299-5.705l-.814.392-.472-.771A3.997 3.997 0 0 0 11 4ZM5.322 6.057A6.002 6.002 0 0 1 15.634 4.19 5 5 0 1 1 17 14h-.6v2.97a.1.1 0 0 0 .1.1h1.29a2.65 2.65 0 1 1-.024 1.8H16.5a1.9 1.9 0 0 1-1.9-1.9V14h-1.7v3.51a2.651 2.651 0 1 1-1.8 0V14H9.422v2.97a1.9 1.9 0 0 1-1.9 1.9H6.255a2.651 2.651 0 1 1-.024-1.8h1.29a.1.1 0 0 0 .1-.1V14H6a4 4 0 0 1-.678-7.943ZM12 19.153a.85.85 0 1 0 0 1.7.85.85 0 0 0 0-1.7Zm-9.1-1.15a.85.85 0 1 1 1.7 0 .85.85 0 0 1-1.7 0Zm17.371-.85a.85.85 0 1 0 0 1.7.85.85 0 0 0 0-1.7Z",
    fill: "#6E7179"
  })));
};
export default SvgLinkedCloud;